import { createSlice } from '@reduxjs/toolkit';
import { proofOfPaymentApi } from '../api/proofOfPaymentApi';

const initialState = {
  proofOfPayments: [],
  selectedProofOfPayment: null,
  loading: false,
  error: null,
};

const proofOfPaymentSlice = createSlice({
  name: 'proofOfPayment',
  initialState,
  reducers: {
    setSelectedProofOfPayment: (state, action) => {
      state.selectedProofOfPayment = action.payload;
    },
    clearSelectedProofOfPayment: (state) => {
      state.selectedProofOfPayment = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle getProofOfPayments
      .addMatcher(
        proofOfPaymentApi.endpoints.getProofOfPayments.matchPending,
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )
      .addMatcher(
        proofOfPaymentApi.endpoints.getProofOfPayments.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.proofOfPayments = action.payload;
        }
      )
      .addMatcher(
        proofOfPaymentApi.endpoints.getProofOfPayments.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        }
      )
      
      // Handle getProofOfPaymentById
      .addMatcher(
        proofOfPaymentApi.endpoints.getProofOfPaymentById.matchFulfilled,
        (state, action) => {
          state.selectedProofOfPayment = action.payload;
        }
      );
  },
});

export const { setSelectedProofOfPayment, clearSelectedProofOfPayment } = proofOfPaymentSlice.actions;

export default proofOfPaymentSlice.reducer;
